import type {
  DataResponse,
  PaginatedResponse,
  Notification,
  ListNotificationsQuery,
  UnreadSummary,
} from '@pms/shared';
import { api } from '@/lib/api';

export const notificationsService = {
  async list(query: Partial<ListNotificationsQuery> = {}): Promise<PaginatedResponse<Notification>> {
    const res = await api.get<PaginatedResponse<Notification>>('/notifications', { params: query });
    return res.data;
  },
  async unreadSummary(): Promise<UnreadSummary> {
    const res = await api.get<DataResponse<UnreadSummary>>('/notifications/unread-count');
    return res.data.data;
  },
  async markRead(id: string): Promise<void> {
    await api.post(`/notifications/${id}/read`);
  },
  async dismiss(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  },
  async markAllRead(): Promise<void> {
    await api.post('/notifications/read-all');
  },
};
